import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import {
  BypassService,
  FeatureToggleProvider,
  RacwaInternalAuth,
  ShieldEnvironmentProvider,
  STORAGE_KEY_NPE_RACWA_CRM_ID,
} from "raci-react-library-npe";
import MainApp from "./App";
import BypassApp from "./__NPE__/BypassApp";
import "./index.css";
import reportWebVitals from "./reportWebVitals";

let App: any;

/*
 ** WARNING: KNOW WHAT YOU'RE DOING BEFORE MAKING CHANGES TO
 ** TO THE BELOW IF STATEMENT
 ** UPON A BUILD, VITE WILL REMOVE CODE IN
 ** THE OUTPUTTED JAVASCRIPT FILE DEPENDING ON THE TARGET
 ** ENVIRONMENT
 ** THIS MEANS THAT FOR LOCAL/DEV/SIT BUILDS WILL INCLUDE
 ** AND SHIP CODE (YOU CAN SEE AND SEARCH FOR IN OUTPUTTED
 ** JAVASCRIPT ARTIFACTS) FOR MICROSOFT AUTHENTICATION LIBRARY
 */
if (
  import.meta.env.VITE_ENVIRONMENT === "LOCAL" ||
  import.meta.env.VITE_ENVIRONMENT === "DEV" ||
  import.meta.env.VITE_ENVIRONMENT === "SIT" ||
  import.meta.env.VITE_ENVIRONMENT === "UAT"
) {


  BypassService.setCrmIdFromQuerystring();
  BypassService.setShieldEnvironmentFromQuerystring();
  BypassService.setOverrideToNumberFromQuerystring();
  BypassService.setFeatureToggleFromQuerystring();
  BypassService.setSourceUrlFromQuerystring();

  // If the bypass CRM ID is set, use the App without the MyRAC auth component
  const AppInternal = sessionStorage.getItem(STORAGE_KEY_NPE_RACWA_CRM_ID)
    ? BypassApp
    : MainApp;

  const featureToggles = JSON.parse(import.meta.env.VITE_FEATURE_TOGGLES ?? "[]");
  const environments = JSON.parse(import.meta.env.VITE_SHIELD_ENVIRONMENTS ?? "[]");

  const NpeApp = () => (
    <FeatureToggleProvider featureToggles={featureToggles}>
      <ShieldEnvironmentProvider environments={environments}>
        <AppInternal />
      </ShieldEnvironmentProvider>
    </FeatureToggleProvider>
  );

  if (import.meta.env.VITE_ENVIRONMENT !== "UAT") {
    App = () => (
      <RacwaInternalAuth
        clientId={import.meta.env.VITE_NPE_OAUTH_CLIENT_ID ?? ""}
        authority={import.meta.env.VITE_NPE_OAUTH_AUTHORITY ?? ""}
        redirectUri={import.meta.env.VITE_ENVIRONMENT === "LOCAL" ? window.location.origin : import.meta.env.BASE_URL}
      >
        <NpeApp />
      </RacwaInternalAuth>
    );
  } else {
    App = () => <NpeApp />;
  }
} else {
  App = MainApp;
}

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint.
reportWebVitals();
